module.exports = __webpack_public_path__ + "img/download.4231196f.svg";